/* eslint-disable */
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";

export default {
    name: "GenericApproveRejectModal",
    components: {
        customModal,
    },
    props: {
        heading: {
            type: String,
            default: "Approve / Reject",
        },
        action1Label: {
            type: String,
            default: "Approve",
        },
        action2Label: {
            type: String,
            default: "Reject",
        },
        apiUrl: {
            type: String,
            required: true,
        },
        payload: {
            type: Object,
            required: true,
        },
        commentsKey: {
            type: String,
            default: "comments",
        },
        statusKey: {
            type: String,
            default: "status",
        },
        statusValueApprove: {
            type: String,
            default: "Approved",
        },
        statusValueReject: {
            type: String,
            default: "Rejected",
        },
        httpMethod: {
            type: String,
            default: "put",
        },
        successMsgApprove: {
            type: String,
            default: "",
        },
        successMsgReject: {
            type: String,
            default: "",
        },
        fromPage: {
            type: String,
            default: "",
        },
         action2IsCancel: {
        type: Boolean,
        default: false,
    },
    },

    emits: ["closePopup", "actionSuccess", "actionError"],

    data() {
        return {
            localComments: "",
            isLoading: false,
            lastAction: null,
            head: {},
        };
    },

    mounted() {
        const idtoken = store.getters.getIdToken;
        this.head = {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
            },
        };
    },

    methods: {
        close() {
            this.$emit("closePopup", { fromPage: this.fromPage });
        },

        async ActionSubmit(actionBool) {
            //if this is the cancel button, just close — no API call
        if (actionBool === false && this.action2IsCancel) {
            this.close();
            return;
        }
            this.isLoading = true;
            this.lastAction = actionBool;

            // Never mutate the prop — spread into a new object
            const finalPayload = { ...this.payload };

            if (this.commentsKey) {
                finalPayload[this.commentsKey] = this.localComments;
            }
            if (this.statusKey) {
                finalPayload[this.statusKey] = actionBool
                    ? this.statusValueApprove
                    : this.statusValueReject;
            }

            try {
                let result;
                if (this.httpMethod.toLowerCase() === "post") {
                    result = await axios.post(this.apiUrl, finalPayload, this.head);
                } else {
                    result = await axios.put(this.apiUrl, finalPayload, this.head);
                }

                const msg = actionBool
                    ? this.successMsgApprove || `${this.action1Label} action completed successfully.`
                    : this.successMsgReject || `${this.action2Label} action completed successfully.`;

                alert(msg);

                this.$emit("actionSuccess", {
                    fromPage: this.fromPage,
                    actionBool,
                    result: result.data,
                });

                this.close();
            } catch (error) {
                console.error("GenericApproveRejectModal API error:", error);
                this.$emit("actionError", {
                    fromPage: this.fromPage,
                    actionBool,
                    error,
                });
            } finally {
                this.isLoading = false;
                this.lastAction = null;
            }
        },
    },
};